var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReviewStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4975 11.0002C19.1996 11.0002 18.9344 10.8117 18.8364 10.5304L15.6611 1.41081C15.443 0.784381 14.557 0.784381 14.3389 1.41081L11.1636 10.5304C11.0656 10.8117 10.8004 11.0002 10.5025 11.0002H1.0298C0.364399 11.0002 0.0743598 11.8412 0.598315 12.2514L8.39445 18.3544C8.62598 18.5356 8.71956 18.8422 8.62871 19.1219L5.60163 28.4394C5.39211 29.0843 6.13025 29.6205 6.67883 29.222L14.5885 23.4751C14.8339 23.2969 15.1661 23.2969 15.4115 23.4751L23.3212 29.222C23.8698 29.6205 24.6079 29.0843 24.3984 28.4394L21.3713 19.1219C21.2804 18.8422 21.374 18.5356 21.6055 18.3544L29.4017 12.2514C29.9256 11.8412 29.6356 11.0002 28.9702 11.0002H19.4975Z",
    fill: "#393E41"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewStar);
export default __webpack_public_path__ + "static/media/review-star.8dea4f31444192134ecc7abd01e18971.svg";
export { ForwardRef as ReactComponent };